export enum AppSettingsConfigKey {
  FileName = 'appSettings.json',
  Path = 'assets/static/configs'
}
